import AxiosConfig from '../../../config/AxiosConfig';
import { setSnackBar } from '../../states/app/staticSlice';
import { useDispatch } from 'react-redux';

function useUpdateShortcuts() {
  const dispatch = useDispatch();
  const updateShortcut = async (update) => {
    try {
      const response = await AxiosConfig.create('post', `/shortcuts/update`)
        .call(update)
        .getResponseData();
      if (response?.status > 300) {
        const messageError = `Error ${response?.status} - ${response?.message} in useUpdateShortcut`;
        dispatch(
          setSnackBar({ open: true, message: messageError, color: 'error' })
        );
      }
      return response;
    } catch (err) {
      console.error('Failed to updating shortcut:', err);
      throw new Error(`updating shortcut failed: ${err.message}`);
    }
  };

  return {
    updateShortcut,
  };
}

export default useUpdateShortcuts;
